<template>
    <div class="details-container">
      <div class="details-header">
          <div class="details-header-title">
            感谢您关注起亚品牌{{carInfo.modelName}}车型，以下是更多相关信息：
          </div>
          <!-- <div class="details-header-buttons">
            <div class="details-header-button btn-light" @click="toggleTopData">
              切换上面内容
            </div>
            <div class="details-header-button btn-light" @click="toggleBottomData">
              切换下面内容
            </div>
          </div> -->
      </div> 
      <div class="details-grid-wrapper">
        <!-- 上方卡片 -->
        <div class="details-buttons-container">
          <!-- 背景图 -->
          <img class="details-bg-image" src="/assets/~/media/images/ai/card_background.png" alt="">
          <div class="details-content">
            <div class="car-info">
                <div class="car-info-left">
                    <div class="car-name">{{ carInfo.modelName }}</div>
                    <div class="car-price">官方指导价&nbsp;<p class="car-price-value">{{ carInfo.guidePrice }}</p>元起</div>
                </div>
                <div class="car-info-right">
                  <div class="car-image-container">
                    <img class="kia-white-logo" src="/assets/~/media/images/ai/kia-white-logo.png" alt="背景图">
                    <img class="car-image" :src="carInfo.detailImgUrlView" alt="车型图"></img>
                  </div>
                  <div class="action-buttons">
                    <div 
                          v-for="(button, index) in buttons" 
                          :key="index"  
                          class="action-button"
                          @click="handleButtonClick(button)"
                           v-if="button.show"
                      >
                          <img class="button-icon button-icon-normal" :src="button.icon" :alt="button.text">
                          <img class="button-icon button-icon-hover" :src="button.iconHover" :alt="button.text">
                          <span class="button-text">{{ button.text }}</span>
                      </div>
                  </div>
                </div>
                
            </div>
          </div>
          <!-- 轮播 -->
           <div class="sell-swiper">
             <div class="sell-swiper-container">
               <div class="swiper-wrapper">
                 <div class="swiper-slide" v-for="(item, index) in sellCarData" :key="index" >
                   <div class="sell-item">
                     <div class="sell-item-image" @click="openSpPreview(index)">
                       <div class="sell-item-category" v-if="item.category">{{ item.category }}</div>
                       <img :src="item.url" :alt="item.title">
                     </div>
                     <div class="sell-item-name">{{ item.title }}</div>
                     <div class="sell-item-desc">{{ item.subTitle }}</div>
                   </div>
                 </div>
                 <!-- 添加右侧留白占位元素 -->
                 <div class="swiper-slide swiper-slide-placeholder" style=" width: 20px;" v-if="sellCarData.length > 0"></div>
               </div>
               <div class="sell-button-prev"><img src="/assets/~/media/images/ai/arrow_l.png" alt=""></div>
               <div class="sell-button-next"><img src="/assets/~/media/images/ai/arrow_r.png" alt=""></div>
             </div>
             <div class="swiper-pagination-sell"></div>
           </div>
        </div>

        <!-- 机器人说话图标 -->
        <div class="robot-talking-container">
          <img class="robot-wholebody" src="/assets/~/media/images/ai/robot-wholebody.png" alt="">
          <div class="robot-talking-text-box">
            <div class="robot-talking-text">起亚已为您检索到官网所有相关信息</div>
            <div class="robot-talking-text">请您浏览</div>
          </div>
        </div>
        <!-- 详情信息 -->
        <div class="details-grid-container" v-if="containerHasData">
          <!-- 左侧内容 -->
          <div class="grid-left">
            <DetailImages 
              :images="imagesData"
              :rows="2"
              :page-size="100"
              :current-page="currentImagePage"
              :total-images="totalImages"
            />
            <DetailVideo
              :videos="videoPageData"
              :rows="1"
              :page-size="100"
              :current-page="currentVideoPage"
              :total-videos="totalVideos"
             
            />

          </div>
          <!-- 右侧内容 -->
          <div class="grid-right" v-if="righthasdata">
            <!-- 上面内容块 -->
            <div class="grid-right-top" v-if="activityHasData">
              <div class="top-content">
                <DetailActivity 
                  title="相关活动"
                  :list="activityData"
                  :is-expanded="!newsHasData"
                  @more-click="onMoreClick"
                />
              </div>
            </div>
            <!-- 下面内容块 -->
            <div class="grid-right-bottom" v-if="newsHasData">
              <div class="bottom-content">
                <DetailZixun 
                  title="相关资讯"
                  :list="newsData"
                  :is-expanded="!activityHasData"
                  @more-click="onMoreClick"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 底部内容 -->
        <div class="details-bottom-container" v-if="announcementHasData">
          <DetailList 
            title="相关信息"
            questionType="相关信息"
            :list="announcementData"
            @more-click="onMoreClick"
          />
        </div>
        <!-- 所有都没数据占位 -->
        <div v-if="!allHasData" class="no-data-placeholder">
          <img src="/assets/~/media/images/ai/no-inf.png" alt="暂无图片" class="no-data-image" />
          <p class="no-data-text">暂无内容</p>
        </div>
        
        <!-- 卖点图片预览弹窗 -->
        <div v-if="spPreviewVisible" class="sp-image-preview-mask" @click.self="closeSpPreview">
         
          <div class="sp-image-preview-panel">
            <img class="sp-close-top" src="/assets/~/media/images/icon/close-white.png" alt="关闭" @click.stop="closeSpPreview" />
            <img class="sp-image" :src="(sellCarData[spCurrentIndex] || {}).url" :alt="(sellCarData[spCurrentIndex] || {}).title || '图片预览'" />
            <!-- <img class="sp-close" src="/assets/~/media/images/icon/close-white.png" alt="关闭" @click.stop="closeSpPreview" /> -->
            <div class="sp-caption">
              <div class="sp-caption-left">
                <div class="sp-main">{{ (sellCarData[spCurrentIndex] || {}).title }}</div>
                <div class="sp-sub">{{ (sellCarData[spCurrentIndex] || {}).subTitle }}</div>
              </div>
              <div class="sp-nav">
                <button class="sp-btn" @click.stop="spPrev" :disabled="spCurrentIndex <= 0">‹</button>
                <span>{{ spCurrentIndex + 1 }} / {{ sellCarData.length }}</span>
                <button class="sp-btn" @click.stop="spNext" :disabled="spCurrentIndex >= sellCarData.length - 1">›</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { aiUrl } from "@/config/base";
  import Swiper from "swiper";
  import DetailList from './detail-parts/DetailList.vue';
  import DetailActivity from './detail-parts/activity.vue';
  import DetailZixun from './detail-parts/zixun.vue';
  import DetailImages from './detail-parts/images.vue';
  import DetailVideo from './detail-parts/video.vue';
  export default {
    name: 'details',
    props: {
      question: {
        type: String,
        default: ''
      },
      questionType: {
        type: String,
        default: ''
      },
    },
    components: {
      DetailList,
      DetailActivity,
      DetailZixun,
      DetailImages,
      DetailVideo
    },
    data() {
      return {
        carModelName: "",
        carInfo: {
          modelName: "",
          guidePrice: "",
          detailImgUrlView: "",
          
        },
        buttons: [
          {
            text: "立即试驾",
            icon: "/assets/~/media/images/ai/icon01_w.png",
            iconHover: "/assets/~/media/images/ai/icon01_b.png",
            link: "",
            show: true
          },
          {
            text: "参数配置",
            icon: "/assets/~/media/images/ai/icon02_w.png",
            iconHover: "/assets/~/media/images/ai/icon02_b.png",
            link: "",
            show: true
          },
          {
            text: "产品手册",
            icon: "/assets/~/media/images/ai/icon03_w.png",
            iconHover: "/assets/~/media/images/ai/icon03_b.png",
            link: "",
            show: true
          },
          {
            text: "前往车型页",
            icon: "/assets/~/media/images/ai/icon04_w.png",
            iconHover: "/assets/~/media/images/ai/icon04_b.png",
            link: "",
            show: true
          } 

        ],
        
        modelData: [],// 车型介绍数据
        activityData: [],// 相关活动
        newsData: [], //相关资讯
        imagesData: [],// 图片数据
        videoPageData: [],// 视频数据
        announcementData: [],// 相关信息

        // 图片分页相关
        currentImagePage: 1,
        totalImages: 12,
        // 视频分页相关
        currentVideoPage: 1,
        totalVideos: 0,
        // 轮播相关
        sellCarData: [],
        sellSwiper: null, 
        
        imagesHasData: false, // 图片是否有数据
        videoHasData: false, // 视频是否有数据
        activityHasData: false, // 活动是否有数据
        newsHasData: false, // 资讯(新闻)是否有数据
        announcementHasData: false, // 相关信息是否有数据
        token: '',
        spPreviewVisible: false,
        spCurrentIndex: 0,
        // 当前问题关键字（首个车型名），用于并发返回的竞态保护
        currentQuestionKey: '',
      }
    },
    computed: {
      righthasdata() {
        return this.activityHasData || this.newsHasData;
      },
      containerHasData() {
        return this.imagesHasData || this.videoHasData || this.activityHasData || this.newsHasData;
      },
      allHasData() {
        return this.imagesHasData || this.videoHasData || this.activityHasData || this.newsHasData || this.announcementHasData;
      }
    },
    created() {
      const userInfo = localStorage.getItem('user');
      var token=''
      if(userInfo){
        this.userInfo = JSON.parse(userInfo)
        token = this.userInfo.token
      }
      this.token = token
    },
    mounted() {
      
      this.$nextTick(() => {
        setTimeout(() => {
          this.initSellSwiper();
        }, 100);
      });

      //暂时
      //this.handleQuestionChange("[\"EV5\"]");
    },
    watch: {
      question: {
        handler(newQuestion) {
          if (newQuestion) {
            console.log('Details组件接收到问题参数:', newQuestion);
            // 这里可以根据问题参数来更新组件内容
            this.handleQuestionChange(newQuestion,this.questionType);
          }
        },
        immediate: true
      }
    },
    methods: {
        onMoreClick(type) {
          this.$emit('more-click',type);
        },
        handleQuestionChange(question,questionType) {

          const { arrayString, firstItem } = this.normalizeQuestion(question);
          this.currentQuestionKey = firstItem || '';
          this.resetDetailState(); 
          this.getModelData(arrayString, firstItem);
          this.getActivity(arrayString, firstItem);
          this.getNews(arrayString, firstItem);
          this.getAnnouncement(arrayString, firstItem);
         

        },
        handleQuestionChangeImgView(question,enhancedQuestion,questionType) {
          const { arrayString, firstItem } = this.normalizeQuestion(question);
          this.currentQuestionKey = firstItem || '';
          this.getImgs( firstItem, enhancedQuestion,questionType);
          this.getVideos(firstItem,enhancedQuestion,questionType);
        },
        // 归一化question，返回标准的数组字符串和首个元素
        normalizeQuestion(question) {
          let processedQuestion = question;
          let firstItem = '';
          try {
            if (typeof question === 'string' && question.startsWith('[') && question.endsWith(']')) {
              const arr = JSON.parse(question);
              if (Array.isArray(arr) && arr.length > 0) {
                firstItem = String(arr[0] || '');
                processedQuestion = JSON.stringify([arr[0]]);
              }
            } else if (typeof question === 'string') {
              firstItem = question;
              processedQuestion = JSON.stringify([question]);
            } else if (Array.isArray(question)) {
              firstItem = String(question[0] || '');
              processedQuestion = JSON.stringify([question[0]]);
            } else if (question != null) {
              firstItem = String(question);
              processedQuestion = JSON.stringify([String(question)]);
            }
          } catch (_) {
            try {
              firstItem = String(question || '');
              processedQuestion = JSON.stringify([firstItem]);
            } catch (__) {
              processedQuestion = '[]';
              firstItem = '';
            }
          }
          return { arrayString: processedQuestion, firstItem };
        },
        // 切换车型时重置本组件数据与标志，并销毁轮播
        resetDetailState() {
          try { if (this.sellSwiper) { this.sellSwiper.destroy(true, true); } } catch (_) {}
          this.sellSwiper = null;
          this.sellCarData = [];
          this.spPreviewVisible = false;
          this.spCurrentIndex = 0;
          this.imagesData = [];
          this.videoPageData = [];
          this.activityData = [];
          this.newsData = [];
          this.announcementData = [];
          this.imagesHasData = false;
          this.videoHasData = false;
          this.activityHasData = false;
          this.newsHasData = false;
          this.announcementHasData = false;
          this.currentImagePage = 1;
          this.currentVideoPage = 1;
        },
        //车型详情和卖点
        async getModelData(question, providedFirst) {
          const that = this;
          let str = providedFirst;
          try { if (!str) { str = JSON.parse(question)[0]; } } catch (_) {}
          const params = new URLSearchParams();
          params.append('modelName', str);
          this.$axios
            .get(
              `${aiUrl}kvVehicle/getVehicleInfoByModel`,
              {
                params,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  token: that.token,
                },
              }
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200 && response.data) {
                if (that.currentQuestionKey && str && that.currentQuestionKey !== String(str)) return; // 竞态保护
                if(response.data.sellingPoints){
                  that.sellCarData = response.data.sellingPoints; // 轮播数据
                  that.$nextTick(() => { that.initSellSwiper(); });
                }
                if(response.data.vehicleDetail){
                  that.carInfo = response.data.vehicleDetail; // 车型信息
                  that.buttons[0].link = response.data.vehicleDetail.testDriveUrl;
                  that.buttons[1].link = response.data.vehicleDetail.specUrl;
                  that.buttons[2].link = response.data.vehicleDetail.manualUrl;
                  that.buttons[3].link = response.data.vehicleDetail.modelPageUrl; 
                  if(response.data.vehicleDetail.manualStatus==1){
                     that.buttons[2].show = true;
                  }else{
                     that.buttons[2].show = false;
                  }
                  if(response.data.vehicleDetail.specStatus==1){
                     that.buttons[1].show = true;
                  }else{
                     that.buttons[1].show = false;
                  } 
                }
              }
            })
        },
        // 获取图片数据
        async getImgs(providedFirst, enhancedQuestion,questionType) {
          const that = this;  
          this.$axios
            .post(
              `${aiUrl}keyword/searchImageByKeywords?pageNum=1&pageSize=100`,
              { 
                type: questionType,
                question: enhancedQuestion,
                model: providedFirst
              },
              {
                headers: {
                  token: that.token,
                },
              }
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.imagesData = response.rows;
                //判断是否有没有数据
                if(that.imagesData && that.imagesData.length > 0){
                  that.imagesHasData = true;
                }else{
                  that.imagesHasData = false;
                }
              }
            })
        },
        // 获取视频数据
        async getVideos(providedFirst, enhancedQuestion, questionType) {
          const that = this;

          this.$axios
            .post(
              `${aiUrl}keyword/searchVideoByKeywords?pageNum=1&pageSize=100`,
              { 
                type: questionType,
                question: enhancedQuestion,
                model: providedFirst,
                pageNum: 1,
                pageSize: 100
              },
              {
                headers: {
                  token: that.token,
                },
              }
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.videoPageData = response.rows;
                //判断是否有没有数据
                if(that.videoPageData && that.videoPageData.length > 0){
                  that.videoHasData = true;
                }else{
                  that.videoHasData = false;
                }
              }
            })
        },
        //获取相关活动数据
        async getActivity(question, providedFirst) {
          const that = this;
  
          this.$axios
            .post(
              `${aiUrl}keyword/searchActivateByKeywords`,
              { question: question,pageNum:1,pageSize:100},
              {
                headers: {
                  token: that.token,
                },
              }
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.activityData = response.rows;
                //判断是否有没有数据
                if(that.activityData && that.activityData.length > 0){
                  that.activityHasData = true;
                }else{
                  that.activityHasData = false;
                }
                // 将相关活动数据上报给父组件（用于传递给 MoreCard）
                try {
                  that.$emit('activity-data', that.activityData);
                } catch (e) {}
              }
            })
        },
        //相关资讯(就是新闻) 
        async getNews(question, providedFirst) {
          const that = this; 
          question = that.processedQuestion(question);
          this.$axios
            .post(
              `${aiUrl}keyword/searchNewsByKeywords`,
              { question: question,pageNum:1,pageSize:100},
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.newsData = response.rows;
                //判断是否有没有数据
                if(that.newsData && that.newsData.length > 0){
                  that.newsHasData = true;
                }else{
                  that.newsHasData = false;
                }
                // 将新闻数据上报给父组件（用于传递给 MoreCard）
                try {
                  that.$emit('news-data', that.newsData);
                } catch (e) {}
              }
            })
        },

        processedQuestion(question){
            // 处理question参数：确保最终传递的是数组类型的字符串，且只包含第一个元素
          let processedQuestion = question; 
          // 检查question是否为字符串形式的数组
          if (typeof question === 'string' && question.startsWith('[') && question.endsWith(']')) {
            try {
              // 将字符串形式的数组解析为真正的数组
              const questionArray = JSON.parse(question);
              // 如果是数组且有元素，只取第一个元素并重新包装成数组字符串
              if (Array.isArray(questionArray) && questionArray.length > 0) {
                processedQuestion = JSON.stringify([questionArray[0]]); // 重新包装成数组字符串
              }
            } catch (e) {
              console.error('解析question数组失败:', e);
              // 解析失败时尝试确保是数组形式的字符串
              try {
                // 检查是否已经是数组形式
                if (!processedQuestion.startsWith('[') || !processedQuestion.endsWith(']')) {
                  processedQuestion = JSON.stringify([processedQuestion]);
                }
              } catch (ee) {
                console.error('格式化question为数组失败:', ee);
              }
            }
          } else {
            // 如果question不是字符串形式的数组，将其包装成数组形式的字符串
            try {
              processedQuestion = JSON.stringify([question]);
            } catch (e) {
              console.error('格式化question为数组失败:', e);
            }
          }
          return processedQuestion;
        },
        //获取相关信息数据
        async getAnnouncement(question, providedFirst) {
          const that = this;      
          question = that.processedQuestion(question);
          this.$axios
            .post(
              `${aiUrl}keyword/searchTextByKeywords`,
              { question: question,pageNum:1,pageSize:100},
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.announcementData = response.data;
                //判断是否有没有数据
                if(that.announcementData && that.announcementData.length > 0){
                  that.announcementHasData = true;
                }else{
                  that.announcementHasData = false;
                }
                // 将相关信息数据上报给父组件（用于传递给 MoreStripe）
                try {
                  that.$emit('announcement-data', that.announcementData);
                } catch (e) {}
              }
            })
        },
        initSellSwiper() {
        if (this.sellSwiper) {
          try { this.sellSwiper.destroy(true, true); } catch (e) {}
        }
        this.sellSwiper = new Swiper('.sell-swiper-container', {
          slidesPerView: 'auto',
          spaceBetween: 5,
          centeredSlides: false,
          grabCursor: true,
          resistance: true,
          resistanceRatio: 0.85,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          resizeObserver: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preloadImages: true,
          updateOnImagesReady: true,
          // 始终显示分页条，即使未溢出
          watchOverflow: false,
          navigation: {
            nextEl: '.sell-button-next',
            prevEl: '.sell-button-prev'
          },
          pagination: {
            el: '.swiper-pagination-sell',
            type: 'progressbar'
          }
        });
      },
      handleButtonClick(item) {
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-点击头部按钮： '+ item.text, 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-点击头部按钮： '+ item.text);
        console.log('点击按钮，跳转到:', item.link)
        // 这里可以添加跳转逻辑
        if (item.link) {
          window.open(item.link, '_blank')
        }
      },
      
      
      // 测试方法：切换上面内容显示状态
      toggleTopData() {
        this.activityHasData = !this.activityHasData;
        console.log('上面内容显示状态:', this.activityHasData);
      },
      
      // 测试方法：切换下面内容显示状态
      toggleBottomData() {
        this.newsHasData = !this.newsHasData;
        console.log('下面内容显示状态:', this.newsHasData);
      },
      openSpPreview(index){
         _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-点击头部第'+ (index+1) + '张图片', 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-点击头部第'+ (index+1) + '张图片');
        if(!Array.isArray(this.sellCarData) || this.sellCarData.length === 0) return;
        this.spCurrentIndex = index || 0;
        this.spPreviewVisible = true;
      },
      closeSpPreview(){
        this.spPreviewVisible = false;
      },
      spPrev(){
        if(this.spCurrentIndex > 0){
          this.spCurrentIndex -= 1;
        }
      },
      spNext(){
        if(this.spCurrentIndex < this.sellCarData.length - 1){
          this.spCurrentIndex += 1;
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .details-container {
      width: 100%;
      height: 100%;
      //   padding: calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw);
      background-color:#F3F4F7;// rgba(6, 20, 31, 1);
    }
    
    
    
    .details-header {
    // height: calc(80 / 1920 * 100vw);
    height: 57px;
    display: flex;
    align-items: center; 
    justify-content: space-between;
    padding: 0 calc(24 / 1920 * 100vw);
    background-color:#F3F4F7;// rgba(6, 20, 31, 1);
    .details-header-title {
      // font-size: calc(16 / 1920 * 100vw);
      font-size: 12px;
      color: #06141F;//rgba(155, 161, 165, 1);
      font-family: 'FZLanTingHeiS-R-GB'; 
    }
    .details-header-buttons {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .details-header-button {
      font-size: calc(12 / 1920 * 100vw);
      margin-left: calc(6 / 1920 * 100vw);
      width: calc(140 / 1920 * 100vw);
      height:calc(46 / 1920 * 100vw); 
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: calc(6 / 1920 * 100vw);
      cursor: pointer;
    }
    .btn-light {
      background-color: #fff;
      color: #333;
    }
    .btn-light:hover {
      background-color: rgba(6, 20, 31, 1);
      color: #fff;
      border: 1px solid #fff;
    }
    .btn-dark {
      background-color: rgba(6, 20, 31, 1);
      color: #fff;
      border: 1px solid #fff;
    }
    .btn-dark:hover {
      background-color: #fff;
      color: rgba(6, 20, 31, 1);
    }
   }
   .details-grid-wrapper {
    padding: calc(20 / 1920 * 100vw) calc(20 / 1920 * 100vw);
    border-radius: calc(12 / 1920 * 100vw) calc(12 / 1920 * 100vw) 0 0;
     overflow: auto;
     background-color: #fff;
    //  height: calc(100% -  80 / 1920 * 100vw);
    height: calc(100% -  57px);
     /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 4px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px; 
      transition: background 0.3s ease;
      
      &:hover {
        background: rgba(0, 0, 0, 0.4);
      }
    }
    
    /* Firefox 滚动条样式 */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);

   }
   
   .details-buttons-container {
     position: relative;
     width: 100%;
      //  aspect-ratio: 1249 / 188;
      // aspect-ratio: 1249 / 409;
     border-radius: calc(12 / 1920 * 100vw);
     overflow: hidden;
     margin-bottom: calc(24 / 1920 * 100vw);
     background-color: rgba(195, 204, 214, 0.7);
     .details-bg-image {
       position: absolute;
       top: 0;
       left: 0;
       width: 100%;
       height: 100%;
       object-fit: cover;
       z-index: 1;
     }
     
     .details-content {
       position: relative;
       z-index: 2;
      //  aspect-ratio: 1249 / 188;
      //  height: 100%;
       display: flex;
       align-items: center;
       padding:calc(30 / 1920 * 100vw);
     }
     
     .car-info {
      width: 100%;
       display: flex;
       justify-content: space-between;
       align-items: center;
       .car-info-left{
        .car-name {
          font-size: 20px;
          
          font-family: 'FZLanTingHeiS-DB-GB';
        }
        .car-price {
          font-size: 14px;
          font-family: 'FZLanTingHeiS-R-GB';
          display: flex;
        }
        .car-price-value {
          font-family: 'KiaSignatureBold';
        }
      }
      .car-info-right{
        display: flex;
        align-items: center;
        .car-image-container{
          position: relative;
          margin-right: 30px;
          width: 230px;
          height: 100px;
          .kia-white-logo{
            position: absolute;
            top: 0;
            right: 0;
            width: 130px;
            z-index: 1;
          }
          .car-image{
            bottom: -10px;
            position: absolute;
            width: 230px;
            object-fit: cover;
            z-index: 2;
          }
        }
       }
     }
     
     .action-buttons {
      height: 70px;
       display: flex;
       gap: 6px;
       align-items: center;
       flex-wrap: wrap;
       max-width: calc((100 + 6) * 2px);
     }
     
     .action-button {
         width: 100px;
         height: 33px;
         display: flex;
         align-items: center;
         justify-content: center;
         gap: 5px;
         position: relative;
         padding-left: 25px;
         
         background-color: rgba(255, 255, 255, 0.9);
         border-radius: 6px;
         cursor: pointer;
       
        &:hover {
          background-color: rgba(6, 20, 31, 1);
          color: #fff;
          
          .button-icon-normal {
            opacity: 0;
          }
          
          .button-icon-hover {
            opacity: 1;
          }
         }
       
        .button-icon {
           width: 22px;
           height: 22px;
           object-fit: contain;
         }
         
         .button-icon-normal {
           opacity: 1;
           transition: opacity 0.3s ease;
           position: absolute;
           left: 8px;
         }
         
         .button-icon-hover {
           opacity: 0;
           transition: opacity 0.3s ease;
           position: absolute;
           left: 8px;
         }
       
       .button-text {
         font-size: 10px;
         font-family: 'FZLanTingHeiS-R-GB';
         white-space: nowrap; 
       }
     }
   }
   
   .details-tab-container {
     background-color: #fff;
     border-bottom: 1px solid rgba(177, 180, 181, 1);
     margin-bottom: calc(10 / 1920 * 100vw);
     
     .tab-list {
       display: flex;
       align-items: center;
     } 
     
     .tab-item {
       width: calc(108 / 1920 * 100vw);
       height: calc(56 / 1920 * 100vw);
       display: flex;
       flex-direction: column;
       align-items: center;
       justify-content: center;
       cursor: pointer;
       position: relative;
       
       .tab-text {
         font-size: calc(16 / 1920 * 100vw);
         font-family: 'FZLanTingHeiS-L-GB';
         color: rgba(0, 0, 0, 0.2);
         transition: all 0.3s ease;
       }
       
       .tab-line {
         position: absolute;
         bottom: 0;
         left: 0;
         width: 100%;
         height: calc(2 / 1920 * 100vw);
         background-color: #fff;
         transition: all 0.3s ease;
       }
       
       &.active {
         .tab-text {
           font-family: 'FZLanTingHeiS-B-GB';
           color: rgba(0, 0, 0, 1);
         }
         
         .tab-line {
           background-color: rgba(0, 0, 0, 1);
         }
       }
       
       &:hover:not(.active) {
         .tab-text {
           color: rgba(0, 0, 0, 0.6);
         }
       }
     }
     
     .tab-divider {
       display: none;
     }
   }

   .robot-talking-container {
    display: flex;
    align-items: start;
    justify-content: start;
    gap: calc(10 / 1920 * 100vw);
    .robot-wholebody {
      width: calc(72 / 1920 * 100vw);
      height: calc(101 / 1920 * 100vw);
    }
    .robot-talking-text-box {
      padding-left: calc(20 / 1920 * 100vw);
      width: calc(327 / 1920 * 100vw);
      height: calc(64 / 1920 * 100vw);
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      border: 1px dashed rgba(219, 219, 219, 1);
      border-radius: calc(20 / 1920 * 100vw);
      background-color: rgba(243, 243, 243, 1);
    }
    .robot-talking-text {
      font-size: calc(16 / 1920 * 100vw);
      font-family: 'FZLanTingHeiS-DB-GB';
      line-height: 1.1;
    }
   }
   
   .details-grid-container {
      //  height: calc(100vh - 78px - 40 / 1920 * 100vw - 80 / 1920 * 100vw - 330 / 1920 * 100vw);
      // position: relative;
      // transform: translateY(calc(-20 / 1920 * 100vw));
      margin-top: calc(-20 / 1920 * 100vw);
      margin-bottom: calc(80 / 1920 * 100vw);
      display: flex;
      align-items: stretch;
      gap: calc(20 / 1920 * 1080px);
      min-height: 100px;

      .grid-left {
        background-color: rgba(249, 250, 251, 1);
        flex: 846 1 0;
        min-width: 0;
        padding: calc(10 / 1920 * 100vw) calc(20 / 1920 * 100vw);
        border: 1px solid rgba(205, 208, 210, 1);
        border-radius: calc(12 / 1920 * 100vw);
      }

      .grid-right {
        flex: 413 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: calc(10 / 1920 * 100vw); // 两块之间的间隔
        
        .grid-right-top {
          flex: 200 0 0; // 上面高度比例200
          background-color: rgba(6, 20, 31, 1);//99999999999999
          border-radius: calc(12 / 1920 * 100vw);


          background-color: rgba(249, 250, 251, 1); 
          border: 1px solid rgba(205, 208, 210, 1);
          
          
          .top-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            
            
          }
        }
        
        .grid-right-bottom {
          flex: 431 0 0; // 下面高度比例431
          background-color: rgba(55, 67, 76, 1);
          border-radius: calc(12 / 1920 * 100vw);
          background-color: rgba(249, 250, 251, 1); 
          border: 1px solid rgba(205, 208, 210, 1);
          .bottom-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
        
        // 当只有上面内容时的样式
        &:has(.grid-right-top:only-child) {
          .grid-right-top {
            flex: 1 1 100%; // 铺满整个高度
          }
        }
        
        // 当只有下面内容时的样式
        &:has(.grid-right-bottom:only-child) {
          .grid-right-bottom {
            flex: 1 1 100%; // 铺满整个高度
          }
        }
      }
           /* 自定义滚动条样式 */
       &::-webkit-scrollbar {
         width: 4px;
         background-color: transparent;
       }
       
       &::-webkit-scrollbar-track {
         background: transparent;
       }
       
       &::-webkit-scrollbar-thumb {
         background: rgba(0, 0, 0, 0.2);
         border-radius: 2px;
         transition: background 0.3s ease;
         
         &:hover {
           background: rgba(0, 0, 0, 0.4);
         }
       }
      
      /* Firefox 滚动条样式 */
      scrollbar-width: thin;
      scrollbar-color: rgba(0, 0, 0, 0.2) #fff;
  }
  

  .sell-swiper {
    position: relative;
    z-index: 2;
    padding: calc(10 / 1920 * 100vw) 0 calc(30 / 1920 * 100vw) calc(30 / 1920 * 100vw);
    height: calc((221 / 409) * 100%);
    min-height: calc(120 / 1080 * 100vh);

    .sell-swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    }

    ::v-deep .swiper-wrapper {
      display: flex;
      flex-wrap: nowrap;
      align-items: stretch;
      width: max-content;
    }

    ::v-deep .swiper-slide {
      // width: calc(211.45 / 1920 * 100vw);
      width: 180px;
      flex: 0 0 auto;
    }

    /* progressbar 分页器，参照 Welcome.vue 的风格 */
    ::v-deep .swiper-pagination-progressbar {
      position: relative;
      width: calc(100% - calc(30 / 1920 * 100vw));
      height: 1px;
      border-radius: 0;
      background-color: rgba(0, 0, 0, 0.2);
      // margin-top: calc(30 / 1920 * 100vw);
      margin-top: 10px;
    }

  ::v-deep .swiper-pagination-progressbar-fill {
    background-color: rgba(0, 0, 0, 0.4);
    display: inline-block;
  }

    .sell-item {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      border-radius: calc(6 / 1920 * 100vw);
      // padding: calc(12 / 1920 * 100vw);
    }
    .sell-item-image:hover {
      // transform: scale(1.02);
      z-index: 10;
    }
    .sell-item-image:hover img {
      transform: scale(1.05);
    }

    .sell-item-image {
      // width: 100%;
      // width: calc(211.45 / 1920 * 100vw);
      // height: calc(122.97 / 1920 * 100vw);
      width: 180px;
      height: 104.53px;
      // aspect-ratio: 211.45 / 122.97;
      background: #000;
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      
      width: 100%;
      height: 100%; 
      cursor: pointer;
      transition: transform 0.3s ease;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.3s ease;
      }

      .sell-item-category {
        position: absolute;
        top: 6px;
        left: 6px;
        height: 20px;
        line-height: 20px;
        padding: 0 8px;
        border-radius: 20px;
        border: 0.8px solid rgba(255, 255, 255, 0.5);
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(30px);
        color: #fff;
        font-size: 10px;
        font-family: 'FZLanTingHeiS-DB-GB';
        white-space: nowrap;
      }
    }

    .sell-item-name {
      margin-top: 4px;
      font-size: 12px;
      font-family: 'FZLanTingHeiS-DB-GB';
      color: #000;
    }

    .sell-item-desc {
      margin-top: 2px;
      font-size: 10px;
      font-family: 'FZLanTingHeiS-R-GB';
      line-height: 1.4;
      white-space: nowrap;
    }

    .sell-button-prev,
    .sell-button-next {
      position: absolute;
      top: 55px;
      transform: translateY(-50%);
      width: 36px;
      height: 36px;
      // border-radius: 50%;
      // background: rgba(255, 255, 255, 0.95);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      cursor: pointer;
      z-index: 5;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .sell-button-prev { left: 10px; }
    .sell-button-next { right: 10px; }

    /* Swiper 到达首尾时会加 disabled 类，直接隐藏 */
    ::v-deep .swiper-button-disabled {
      display: none !important;
    }
  }
  .details-bottom-container {
    border: 1px solid rgba(205, 208, 210, 1);
    border-radius: calc(12 / 1920 * 100vw);
    padding: calc(20 / 1920 * 100vw) calc(20 / 1920 * 100vw);
    background-color: rgba(249, 250, 251, 1);
    margin-top: calc(-20 / 1920 * 100vw);
    // margin-bottom: calc(40 / 1920 * 100vw);
    position: relative;
    z-index: 10;
  }

  
  .no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  aspect-ratio: 1279 / 342;
  margin-top: calc(-20 / 1920 * 100vw);
  position: relative;
  z-index: 10;
  background-color: rgba(249, 250, 251, 1);
  border-radius: calc(12 / 1920 * 100vw);
  border: 1px solid rgba(205, 208, 210, 1);
}

.no-data-image {
  width: calc(64 / 1920 * 100vw);
  height: calc(54 / 1920 * 100vw);
  margin-bottom: calc(8 / 1920 * 100vw);
  opacity: 0.5;
}

.no-data-text {
  color: rgba(186, 192, 196, 1);
  font-size: calc(12 / 1920 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  margin: 0;
}
  
  .sp-image-preview-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    z-index: 100000;
  }
  .sp-image-preview-panel {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(1140 / 1080 * 100vh);
    height: calc(684 / 1080 * 100vh);
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sp-close-top {
    position: absolute;
    top: -10px;
    right: -30px;
    width: calc(28 / 1080 * 100vh);
    height: calc(28 / 1080 * 100vh);
    cursor: pointer;
    z-index: 1;
  }
  .sp-image { width: 100%; height: 100%; object-fit: contain; }
  /* 贴合图片右上角的关闭按钮（位于图片容器内侧） */
  .sp-close {
    position: absolute;
    top: calc(10 / 1080 * 100vh);
    right: calc(10 / 1080 * 100vh);
    width: calc(30 / 1080 * 100vh);
    height: calc(30 / 1080 * 100vh);
    cursor: pointer;
    z-index: 2;
  }
  /* 卖点预览标题条：移动到图片底部下方 20px，仅影响卖点弹层 */
  .sp-caption { position: absolute; top: calc(50% + 342 / 1080 * 100vh + 20px); left: 50%; transform: translateX(-50%); width: calc(1140 / 1080 * 100vh); display: flex; align-items: center; justify-content: space-between; color: #fff; }
  .sp-caption-left { display: flex; flex-direction: column; gap: calc(4 / 1080 * 100vh); }
  .sp-main { font-size: calc(16 / 1080 * 100vh); font-family: 'FZLanTingHeiS-B-GB'; }
  .sp-sub { font-size: calc(12 / 1080 * 100vh); opacity: .85; }
  .sp-nav { display: flex; align-items: center; gap: calc(8 / 1080 * 100vh); }
  .sp-btn {
    width: calc(40 / 1080 * 100vh);
    height: calc(40 / 1080 * 100vh);
    border-radius: 50%;
    border: none;
    background: #fff;
    color: #05141F;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    font-size: calc(18 / 1080 * 100vh);
    font-weight: 700;
  }
  .sp-btn:hover { background: #05141F; color: #fff; }
  .sp-btn:disabled { background: lightgrey; color: rgba(0,0,0,.5); cursor: not-allowed; box-shadow: none; }
  ::v-deep .swiper-slide-placeholder { 
    height: 1px; /* 高度设为最小，不影响布局 */
    opacity: 0; /* 透明化，不显示 */
  }
  </style>
  